module.exports = __webpack_public_path__ + "img/Left.092c44e4.jpg";